import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { RevealLines, Reveal } from "@/components/motion";

const VISION_IMG =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_branding-lab-8/artifacts/1m5htjgh_ChatGPT%20Image%20Aug%207%2C%202026%2C%2009_00_14%20AM.png";

export const VisionMission = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section
      ref={ref}
      className="relative py-28 md:py-40 bg-[#26231F] text-[#FDFBF7] overflow-hidden"
      data-testid="vision-mission"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-16 lg:gap-20 items-center">
        <div className="relative overflow-hidden order-2 lg:order-1">
          <motion.img
            style={{ y }}
            src={VISION_IMG}
            alt="Aurelume vision"
            className="w-full h-[420px] md:h-[560px] object-cover"
          />
        </div>

        <div className="order-1 lg:order-2">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-8">
            — Vision &amp; Mission
          </p>
          <h2 className="font-serif font-light text-4xl md:text-6xl leading-[0.98] tracking-tight">
            <RevealLines
              lines={["We build brands", "that outlive the", "campaign that", "launched them."]}
            />
          </h2>

          <div className="mt-10 space-y-8 max-w-lg">
            <Reveal i={0}>
              <div className="border-l border-[#C5A059]/40 pl-6">
                <h3 className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-2">
                  Our Vision
                </h3>
                <p className="text-base md:text-lg text-[#FDFBF7]/70 leading-relaxed">
                  A world where the most trusted names in every category earned
                  that trust deliberately — because someone dared to build a
                  brand from the inside out.
                </p>
              </div>
            </Reveal>
            <Reveal i={1}>
              <div className="border-l border-[#C5A059]/40 pl-6">
                <h3 className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-2">
                  Our Mission
                </h3>
                <p className="text-base md:text-lg text-[#FDFBF7]/70 leading-relaxed">
                  To turn ambitious institutions into category leaders through
                  strategy, creativity and data — engineering credibility that
                  compounds, one believable touchpoint at a time.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
